import {
  SSO_LOADING,
  SSO_DATA,
} from './SsoActions';

const INITIAL_STATE = {
  error: '',
  loaded: false,
  loading: true,
  sso: null,
};

const SsoReducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case SSO_LOADING:
      return {
        ...state,
        loading: action.payload,
      };
    case SSO_DATA:
      return {
        ...state,
        error: '',
        loaded: action.payload.loaded,
        loading: false,
        sso: action.payload.data,
      };
  }

  return state;
};

export default SsoReducer;
